import { RestRequest, RestContext, ResponseFunction } from 'msw'
import {
  addToEntityListData,
  updateEntityListData,
  deleteEntityListData,
} from '../../modules/mockDataCommon'
import { requireAuthenticatedUser } from '../../decorators'
import { getProjectListData, getProjectOverviewDataById } from './mockData'
import type { IProject, IProjectOverview } from '~/types/project/models'

interface GetProjectsResponse {
  data: IProject[]
}

async function getProjects(
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) {
  console.log(`'Returning projects.`)
  const responseBody = { data: await getProjectListData() }
  return res(ctx.status(200), ctx.json(responseBody))
}

interface GetProjectOverviewResponse {
  data: IProjectOverview[]
}

const getProjectOverview_byId = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  const { id } = req.params
  if (typeof id !== 'string') {
    const responseBody = {
      statusCode: 500,
      message: 'Passed ID is not a string.',
    }
    return res(ctx.status(500), ctx.json(responseBody))
  }
  try {
    const responseBody: GetProjectOverviewResponse = {
      data: await getProjectOverviewDataById(id)!, // will either be valid or will have thrown error
    }
    return res(ctx.status(200), ctx.json(responseBody))
  } catch (e) {
    const responseBody = {
      statusCode: 404,
      message: `Unable to retrieve project overview for '${id}'`,
    }
    return res(ctx.status(404), ctx.json(responseBody))
  }
}

// post

const postProject = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return addToEntityListData(req, res, ctx, getProjectListData)
}

const patchProject = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return updateEntityListData(req, res, ctx, getProjectListData)
}

const deleteProject = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return deleteEntityListData(req, res, ctx, getProjectListData)
}

export const handlers = [
  {
    method: 'get',
    path: '/api/projects',
    handler: getProjects,
  },
  {
    method: 'get',
    path: '/api/projects/:id/overview',
    handler: getProjectOverview_byId,
  },
  {
    method: 'post',
    path: '/api/projects',
    handler: postProject,
  },
  {
    method: 'patch',
    path: '/api/projects/:id',
    handler: patchProject,
  },
  {
    method: 'delete',
    path: '/api/projects/:id',
    handler: deleteProject,
  },
].map((h) => ({ ...h, ...{ handler: requireAuthenticatedUser(h.handler) } }))
